import axios from "axios";

export default async function getCsrfToken(){
  const { data } = await axios.get('/api/ctk');
  const { csrfToken } = data;

  return csrfToken;
};
